var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_832_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_833_",
    style: {
      fill: "#A78966"
    },
    d: "M309.46,361.87c12.88-25.796,21.558-57.517,25.358-91.87h-40.25 c-3.481,27.963-10.622,53.459-20.938,74.09c-7.104,14.209-15.22,25.022-23.63,31.786V270h-40v190h40v-37.026 c84.257-8.669,152.695-71.49,169.844-152.974h-41.118C368.285,308.778,343.047,341.555,309.46,361.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_834_",
    style: {
      fill: "#B39A7C"
    },
    d: "M186.37,344.09c-10.316-20.631-17.457-46.127-20.938-74.09h-40.25 c3.799,34.353,12.478,66.074,25.358,91.87c-33.587-20.315-58.825-53.092-69.266-91.87H40.156 C57.305,351.487,125.742,414.313,210,422.98v-47.1C201.59,369.11,193.47,358.3,186.37,344.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_835_",
    style: {
      fill: "#FF7956"
    },
    d: "M441.78,196.46c8.22-10.18,11.31-24.17,6.96-37.53 c-4.34-13.37-15.06-22.88-27.69-26.27c4.68-12.22,3.29-26.48-4.98-37.85c-8.26-11.37-21.39-17.1-34.45-16.43 c0.67-13.06-5.06-26.19-16.43-34.45c-11.37-8.27-25.63-9.66-37.85-4.98c-3.39-12.63-12.9-23.35-26.27-27.69 c-13.36-4.35-27.35-1.26-37.53,6.96C256.41,7.26,244.06,0,230,0v270h190c22.09,0,40-17.91,40-40 C460,215.94,452.74,203.59,441.78,196.46z M280,152.66c-11.046,0-20-8.954-20-20s8.954-20,20-20s20,8.954,20,20 S291.046,152.66,280,152.66z M320,220c-11.046,0-20-8.954-20-20s8.954-20,20-20s20,8.954,20,20S331.046,220,320,220z M360,152.66 c-11.046,0-20-8.954-20-20s8.954-20,20-20s20,8.954,20,20S371.046,152.66,360,152.66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_840_",
    style: {
      fill: "#FF9478"
    },
    d: "M230,270V0c-14.06,0-26.41,7.26-33.54,18.22c-10.18-8.22-24.17-11.31-37.53-6.96 c-13.37,4.34-22.88,15.06-26.27,27.69c-12.22-4.68-26.48-3.29-37.85,4.98c-11.37,8.26-17.1,21.39-16.43,34.45 c-13.06-0.67-26.19,5.06-34.45,16.43c-8.27,11.37-9.66,25.63-4.98,37.85c-12.63,3.39-23.35,12.9-27.69,26.27 c-4.35,13.36-1.26,27.35,6.96,37.53C7.26,203.59,0,215.94,0,230c0,22.09,17.91,40,40,40H230z M180,112.66c11.046,0,20,8.954,20,20 s-8.954,20-20,20s-20-8.954-20-20S168.954,112.66,180,112.66z M140,180c11.046,0,20,8.954,20,20s-8.954,20-20,20s-20-8.954-20-20 S128.954,180,140,180z M100,112.66c11.046,0,20,8.954,20,20s-8.954,20-20,20s-20-8.954-20-20S88.954,112.66,100,112.66z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_845_",
    style: {
      fill: "#FF7956"
    },
    cx: 140,
    cy: 200,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_846_",
    style: {
      fill: "#FF7956"
    },
    cx: 100,
    cy: 132.66,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_847_",
    style: {
      fill: "#FF7956"
    },
    cx: 180,
    cy: 132.66,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_848_",
    style: {
      fill: "#FF9478"
    },
    cx: 320,
    cy: 200,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_849_",
    style: {
      fill: "#FF9478"
    },
    cx: 360,
    cy: 132.66,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_850_",
    style: {
      fill: "#FF9478"
    },
    cx: 280,
    cy: 132.66,
    r: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.2e7ff3d82cee8a5c2ce188973d096d3e.svg";
export { ForwardRef as ReactComponent };